<div class="envio-simple-page">
  <h1 class="envio-simple-page__title">Envío simple</h1>

  <app-envio-simple-stepper
    [elementos]="envioSimpleFlowService.PASOS"
    [stepActive]="envioSimpleFlowService.pasoActivo">
  </app-envio-simple-stepper>

  <section class="firmantes-layout">
    <aside class="firmantes-layout__col firmantes-layout__documentos">
      <app-envio-simple-ficheros-subidos
        class="firmantes-layout__lista"
        [titulo]="'Documentos'"
        [orientacion]="'vertical'"
        [seleccionable]="true">
      </app-envio-simple-ficheros-subidos>

      <div class="firmantes-layout__dropzone">
        <app-envio-simple-zona-carga [mostrarGenerico]="false"></app-envio-simple-zona-carga>
      </div>
    </aside>

    <main class="firmantes-layout__col firmantes-layout__preview">
      <ng-container *ngIf="pdfSrc">
        <app-configuracion-documento-upload
          *ngFor="let docId of [documentoActivoId]; trackBy: trackByDocId"
          [src]="pdfSrc"
          [pdfCargado]="true"
          [indexPaso]="indexPaso"
          [modoEnvioSimple]="true"
          [firmanteSeleccionado]="firmanteSeleccionado">
        </app-configuracion-documento-upload>
      </ng-container>
    </main>

    <aside class="firmantes-layout__col firmantes-layout__firmantes">
      <ng-container *ngIf="documentoActivoId">
        <app-configuracion-documento-panel-firmantes-unificado
          *ngFor="let docId of [documentoActivoId]; trackBy: trackByDocId"
          (firmanteSeleccionado)="onFirmanteSeleccionado($event)">
        </app-configuracion-documento-panel-firmantes-unificado>
      </ng-container>
    </aside>
  </section>
</div>

<div class="envio-simple-footer">
  <div class="envio-simple-footer__left">
    <app-boton-accion-secundaria (click)="volver()" [id]="'volver-firmantes'" [icono]="'hs-arrow-back'" [titulo]="'Volver'"></app-boton-accion-secundaria>
  </div>
  <div class="envio-simple-footer__right botonera-rigth" (click)="onContinuarClick()">
    <app-boton-accion [id]="'siguiente-firmantes'" [titulo]="'Siguiente'" [disabled]="!puedeContinuar" (botonClicked)="siguiente()"></app-boton-accion>
  </div>
</div>
